import { Controller } from '@hotwired/stimulus'

// used for now only in my shifts calendar but may be refactored to use in other ones too
export default class extends Controller {
  static values = { loading: { type: Boolean, default: true } }
  static targets = ['frame', 'loader']
  
  connect() {
    addEventListener('turbo:before-fetch-request', async (event) => {
      //console.log('calendar--loading | turbo:before-fetch-request | event.target', event.target)

      const target_id = event.target.getAttribute('id')

      if(!target_id || target_id.startsWith('calendar') || target_id.endsWith('-roster-shift')) {
        this.loadingValue = true
      }
    })

    this.frameTarget.addEventListener('turbo:frame-render', async (event) => {
      //console.log('calendar--loading | turbo:frame-render', event)

      //this.renderPopovers() // may be added someday app wide
      this.loadingValue = false
    })

    addEventListener('turbo:before-stream-render', async (event) => {
      //const target = event.target.getAttribute('target')

      // console.log('calendar--loading | turbo:before-stream-render', event)

      this.loadingValue = false
    })

    // addEventListener('turbo:fetch-request-error', ({ _target }) => {
    //   this.loadingValue = false
    // })

    // addEventListener('turbo:render', (event) => {
    //   console.log('calendar--loading | turbo:render', event)
    // });

    // addEventListener("turbo:before-frame-render", (event) => {
    //   console.log('calendar--loading | turbo:before-frame-render', event)
    // })

    // addEventListener('turbo:before-render', (event) => {
    //   console.log('calendar--loading | turbo:before-render')
    // })

    // addEventListener("turbo:before-frame-load", async (event) => {
    //   console.log("calendar--loading | turbo:before-frame-load")
    // })
  }

  loadingValueChanged() {
    if(!this.hasLoaderTarget) {
      return
    }

    if(this.loadingValue) {
      this.loaderTarget.classList.add('loading')
    } else {
      this.loaderTarget.classList.remove('loading')
    }
  }
}
